<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="userId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价出价记录.出价用户id')}}<template slot="title">{{$t('询价出价记录.出价用户id')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.userId"  :placeholder="$t('通用.输入.请输入')+$t('询价出价记录.出价用户id')" />
      </a-form-model-item>
      <a-form-model-item prop="activityId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价出价记录.询价活动ID')}}<template slot="title">{{$t('询价出价记录.询价活动ID')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.activityId"  :placeholder="$t('通用.输入.请输入')+$t('询价出价记录.询价活动ID')" />
      </a-form-model-item>
      <a-form-model-item prop="goodsId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价出价记录.询价商品ID')}}<template slot="title">{{$t('询价出价记录.询价商品ID')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.goodsId"  :placeholder="$t('通用.输入.请输入')+$t('询价出价记录.询价商品ID')" />
      </a-form-model-item>
      <a-form-model-item prop="sort" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价出价记录.排序')}}<template slot="title">{{$t('询价出价记录.排序')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.sort"  :placeholder="$t('通用.输入.请输入')+$t('询价出价记录.排序')" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价出价记录.备注')}}<template slot="title">{{$t('询价出价记录.备注')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="payBond" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价出价记录.是否需要缴纳保证金 0:否 1:是')}}<template slot="title">{{$t('询价出价记录.是否需要缴纳保证金 0:否 1:是')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.payBond"  :placeholder="$t('通用.输入.请输入')+$t('询价出价记录.是否需要缴纳保证金 0:否 1:是')" />
      </a-form-model-item>
      <a-form-model-item prop="bondMoney" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价出价记录.保证金金额')}}<template slot="title">{{$t('询价出价记录.保证金金额')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.bondMoney"  :placeholder="$t('通用.输入.请输入')+$t('询价出价记录.保证金金额')" />
      </a-form-model-item>
      <a-form-model-item prop="payMethod" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价出价记录.支付方式 1:支付宝 2:微信')}}<template slot="title">{{$t('询价出价记录.支付方式 1:支付宝 2:微信')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.payMethod"  :placeholder="$t('通用.输入.请输入')+$t('询价出价记录.支付方式 1:支付宝 2:微信')" />
      </a-form-model-item>
      <a-form-model-item prop="payType" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价出价记录.付款方式 10:现金支付 20:线上转账')}}<template slot="title">{{$t('询价出价记录.付款方式 10:现金支付 20:线上转账')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="payStatus" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价出价记录.支付状态 10:未支付 20:支付成功')}}<template slot="title">{{$t('询价出价记录.支付状态 10:未支付 20:支付成功')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="endMoney" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价出价记录.底价')}}<template slot="title">{{$t('询价出价记录.底价')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.endMoney"  :placeholder="$t('通用.输入.请输入')+$t('询价出价记录.底价')" />
      </a-form-model-item>
      <a-form-model-item prop="quoMoney" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价出价记录.报价金额')}}<template slot="title">{{$t('询价出价记录.报价金额')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.quoMoney"  :placeholder="$t('通用.输入.请输入')+$t('询价出价记录.报价金额')" />
      </a-form-model-item>
      <a-form-model-item prop="deliverDate" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价出价记录.交付时间')}}<template slot="title">{{$t('询价出价记录.交付时间')}}</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.deliverDate" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="bidStatus" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价出价记录.中标状态 10:待开标 20:已中标 30:未中标')}}<template slot="title">{{$t('询价出价记录.中标状态 10:待开标 20:已中标 30:未中标')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getActivityChujia, addActivityChujia, updateActivityChujia } from '@/api/activityChujia/activityChujia'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        activityId: null,

        goodsId: null,

        sort: null,

        createTime: null,

        remark: null,

        payBond: null,

        bondMoney: null,

        payMethod: null,

        payType: null,

        payStatus: 0,

        endMoney: null,

        quoMoney: null,

        deliverDate: null,

        bidStatus: 0

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: this.$t('询价出价记录.出价用户id')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        activityId: [
          { required: true, message: this.$t('询价出价记录.询价活动ID')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        goodsId: [
          { required: true, message: this.$t('询价出价记录.询价商品ID')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        activityId: null,
        goodsId: null,
        sort: null,
        createTime: null,
        remark: null,
        payBond: null,
        bondMoney: null,
        payMethod: null,
        payType: null,
        payStatus: 0,
        endMoney: null,
        quoMoney: null,
        deliverDate: null,
        bidStatus: 0
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getActivityChujia({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateActivityChujia(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addActivityChujia(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
